<template>
    <div class="elHeader" :class="navTop>2?'handerNavFixed':''">
        <div class="handerTop" v-if="navTop<2">
            <div class="topContent">
                <div class="name"><i class="iconfont iconxiaochengxu"></i> 手机小程序</div>
                <div class="name"><i class="iconfont iconzu1564"></i> 在线客服</div>
            </div>
        </div>
        <div class="handerNav">
            <div class="projectLogo"><img src="../../public/images/logo.png" alt=""></div>
            <ul class="handerNavUl">
                <li :class="item.isChecked?'navLiCheck':'navLi'" v-for="(item,index) in navList" :key="index">
                    <span class="lable" @click="tabsClick(item)">{{item.label}}</span>
                    <div class="twoMenu" v-if="!item.content">
                        <div class="item" :class="{'itemChecked':em.emChecked}" v-for="(em,inx) in item.list" :key="index+'_'+inx" @click.stop="tabsClickTwo(item,em)">{{em.label}}</div>
                    </div>
                </li>
                
                <!-- <li class="navOperat">
                    <div class="freeAdmission" @click="tabsClick(freeTrial)">免费试用</div>
                </li> -->
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    props:{
        navTop:{
            type:Number
        }
    },
    data(){
        return{
            navList:[
                {label:'首页',name:'home',code:'index',isChecked:true,content:true,},
                {
                    label:'企业服务',name:'',isChecked:false,content:false,
                    list:[
                        {label:'在线企业服务',name:'enterprise',code:'online_service',emChecked:false,content:true,},
                        {label:'松木ERP系统',name:'supplyChain',code:'sm_system',emChecked:false,content:true,},
                        {label:'仓库WMS系统',name:'warehouseChain',code:'wh_system',emChecked:false,content:true,},
                        {label:'车辆QMS系统',name:'vehicleChain',code:'vehicle_system',emChecked:false,content:true,},
                        {label:'金融FS系统',name:'financeChain',code:'finance_system',emChecked:false,content:true,},
                        {label:'硬木ERP系统',name:'pumuChain',code:'pm_system',emChecked:false,content:true,}
                    ],
                },
                {label:'供应链服务',name:'',isChecked:false,content:false,
                    list:[
                        {label:'在线金融',name:'freeTrial',code:'online_finance',emChecked:false,content:true,},
                        {label:'现货融',name:'spotFinanc',code:'goods_stock',emChecked:false,content:true,},
                        {label:'代赎货',name:'goodsFinanc',code:'to_redeemed',emChecked:false,content:true,},
                        {label:'订单融',name:'orderFinanc',code:'order',emChecked:false,content:true,},
                    ],
                },
                {label:'数据服务',name:'dataCon',code:'data_service',isChecked:false,content:true,},
                {label:'产品价格',name:'productPrice',code:'product_price',isChecked:false,content:false,
                    list:[
                        {label:'松木ERP',name:'supplyPrice',code:'sm_price',emChecked:false,content:true,},
                        {label:'德木云仓',name:'warehousePrice',code:'wh_price',emChecked:false,content:true,},
                        {label:'金融系统',name:'financePrice',code:'finance_price',emChecked:false,content:true,},
                        {label:'硬木ERP',name:'pumuPrice',code:'pm_price',emChecked:false,content:true,},
                        {label:'德木云链',name:'cloudChainPrice',code:'cloud_chain_price',emChecked:false,content:true,},
                    ],
                },

                {label:'合作企业',name:'cooperation',code:'company_cooperation',isChecked:false,content:true,},
                {label:'关于德木',name:'introduce',code:'about_me',isChecked:false,content:true,},
                {label:'联系我们',name:'contact',code:'contact_me',isChecked:false,content:true,},
            ],
            freeTrial:{label:'免费试用',name:'免费试用',isChecked:false,content:true,}
        }
    },
    created(){},
    computed:{
        ...mapState({
            current_tabs: state => state.app.current_tabs,
        }),
    },
    mounted(){
        
    },
    methods:{
        tabsClick(item){
            let {navList} = this.$data;
            if(!item.content || item.code =="data_service"){
                return
            }
            let arrList = this.current_tabs.map(em=>em.code);
            if(arrList.indexOf(item.code) ==-1){
                let newArr = [];
                newArr.push(
                    {code:item.code,content:item.name}
                );
                this.$store.commit('currentTabsList',newArr.concat(this.current_tabs));
            };
            this.$store.commit('currentTabShow',item.code);

            navList.forEach(em => {
                if(em.code == item.code){
                    em.isChecked = true;
                }else{
                    em.isChecked = false;
                }
                if(!em.list){
                    return
                }
                em.list.forEach(li=>{
                    li.emChecked = false;
                }) 
            });
        },
        tabsClickTwo(item,twoItem){
            let {navList} = this.$data;
            let arrList = this.current_tabs.map(em=>em.code);
            if(arrList.indexOf(twoItem.code) ==-1){
                let newArr = [];
                newArr.push(
                    {code:twoItem.code,content:twoItem.name}
                );
                this.$store.commit('currentTabsList',newArr.concat(this.current_tabs));
            };
            this.$store.commit('currentTabShow',twoItem.code);

            navList.forEach(em => {
                if(em.code == item.code){
                    // em.isChecked = true;
                }else{
                    em.isChecked = false;
                }
                if(!em.list){
                    return
                }
                
                em.list.forEach(li=>{
                    if(li.code == twoItem.code){
                        li.emChecked = true;
                    }else{
                        li.emChecked = false;
                    }
                })                
            });
        },
    }
}
</script>

<style scoped>
    .handerTop{height: 3.4rem;background: #0C214D;color: #fff;display: flex;align-items: center;justify-content: center;}
    .topContent{display: flex;align-items: center;justify-content: flex-end;width: 120rem;}
    .topContent .name{margin-left: 2rem;color: #ddd;font-size: 1.2rem;}    

    .handerNavFixed{position: fixed;top: 0;left: 0;z-index: 25;background: rgba(255, 255, 255, 0.9);box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.2);}

    .handerNav{max-width: 120rem;margin: 0 auto;height: 5.4rem;display: flex;flex-direction: row;font-size: 1.4rem;}
    .handerNav .projectLogo{display: flex;align-items: center;justify-content: flex-start;}
    .handerNav .projectLogo img{height: auto;}
    .handerNav .handerNavUl{display: flex;justify-content: flex-end;flex: 1;}
    .handerNavUl .navLi{position: relative;cursor: pointer;height: 5.4rem;display: flex;align-items: center;}
    .handerNavUl .navLi .lable,.handerNavUl .navLiCheck .lable{display: flex;align-items: center;padding: 0 2rem;height: 100%;justify-content: center;}
    .handerNavUl .navLi:last-child .lable{padding-right: 0;}
    .handerNavUl .navLiCheck{background: #D4DDF5;color: #3A6DF3;position: relative;cursor: pointer;display: flex;align-items: center;}
    .handerNavUl .navLiCheck .arrow{display: block;}
    
    .handerNavUl .navLiCheck:after{position: absolute;left: 0;bottom: 0;content:'';width: 100%;height: 1px;background: #3A6DF3;margin: 0 auto;opacity: 1;}
    .handerNavUl .navLi::after{width: 100%;height: 1px;background: #3A6DF3;display: block;margin: 0 auto;-webkit-transform: rotateX(45deg);transform: rotateX(45deg);}
    .handerNavUl .navLi::before{width: 100%;height: 1px;background: #3A6DF3;display: block;margin: 0 auto;-webkit-transform: rotateX(0);transform: rotateX(0);}
    .handerNavUl .navLi::after,.handerNavUl .navLi::before{position: absolute;left: 0;bottom: 0;content:'';opacity:0;-webkit-transition:opacity .3s,-webkit-transform .3s;transition:opacity .3s,transform .3s;pointer-events: none;}
    .handerNavUl .navLi:hover{background: #D4DDF5;}
    .handerNavUl .navLi:hover .twoMenu,.handerNavUl .navLiCheck:hover .twoMenu{position: absolute;left: 0;top: 0;z-index: 10;transform: translateY(0);-webkit-transform:translateY(0);opacity: 1;top: 5.6rem;display:block;}
    
    .handerNavUl .navOperat{padding-left: 1rem;display: flex;align-items: center;justify-content: center;}
    .handerNavUl .navOperat .freeAdmission{padding: 0 1rem; height: 3rem;background: #2E6AFB;color: #fff; text-align: center;line-height: 3rem;border-radius: .4rem;border: 1px solid #fff;}
    .handerNavUl .navOperat .freeAdmission:hover{background: #6392ff;cursor: pointer;}

    /* 二级菜单 */
    .twoMenu{position: absolute;left: 0;top: 5.4rem;z-index: -10;letter-spacing:0.1rem;background: #fff;text-align: center; box-shadow:0.4 0.6 0.2 rgba(0, 0, 0, .4);border-radius: 0.4rem;transition: all .3s;transform: translateY(5.4rem); opacity: 0;display: none;}
    .twoMenu .item{height: 4rem; width: 14rem; display: flex;align-items: center;justify-content: center;}
    .twoMenu .item:last-child{border-bottom-left-radius: 0.4rem;border-bottom-right-radius: 0.4rem;}
    .twoMenu .item:hover{background: #D4DDF5;color: #3A6DF3;}
    .twoMenu .itemChecked{background: #D4DDF5;color: #3A6DF3;}
</style>
